import { render, staticRenderFns } from "./Gate.vue?vue&type=template&id=fbbe2640&scoped=true"
import script from "./Gate.vue?vue&type=script&lang=js"
export * from "./Gate.vue?vue&type=script&lang=js"
import style0 from "./Gate.vue?vue&type=style&index=0&id=fbbe2640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbe2640",
  null
  
)

export default component.exports